// /src/components/modal/styles.ts
import styled from "styled-components";

export const Overlay = styled.div<{ zIndex: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(10, 16, 30, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${(props) => props.zIndex};
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background-color: var(--surface, #fff);
  border: 1px solid var(--border, #e2e8f2);
  border-radius: var(--radius-lg, 18px);
  box-shadow: var(--shadow-lg, 0 24px 56px rgba(15, 26, 46, 0.22));
  min-width: 300px;
  max-width: 95vw;
  max-height: 85vh;

  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background-color: var(--surface, #fff);
  border-bottom: 1px solid var(--border, #e2e8f2);
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: var(--radius-lg, 18px);
  border-top-right-radius: var(--radius-lg, 18px);
`;

export const Title = styled.h2`
  color: var(--ink, #0f1a2e);
  margin: 0;
  padding: 0;
  font-family: var(--font-display, inherit);
  font-size: 17px;
  font-weight: 800;
`;

export const Content = styled.div`
  padding: 26px 28px;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
  color: var(--ink, #0f1a2e);
  font-family: var(--font-body, inherit);
`;

export const Button = styled.button`
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 10px;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-soft, #4c5670);

  &:hover {
    background: var(--surface-2, #f7f9fc);
    color: var(--ink, #0f1a2e);
  }
`;
